import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  static targets = ["result", "loadingIcon", "buttonText"];

  static values = {
    app: String,
    recordid: String,
    urlsolution: String,
    filtertype: String,
  };

  connect() {
    console.log("contacts_employes JS en cours ...");
    super.connect();
  window.initIntTelSimple = this.initIntTel;
    if (
      $("#partial-missions-content").length &&
      $("#partial-missions-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_missions(), 300);
    }

    if (
      $("#partial-primes-content").length &&
      $("#partial-primes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_primes(), 300);
    }

    if (
      $("#partial-paies-content").length &&
      $("#partial-paies-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_paies(), 300);
    }

    if (
      $("#partial-campagne_destinataires-content").length &&
      $("#partial-campagne_destinataires-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_campagne_destinataires(), 300);
    }

    if (
      $("#partial-collab_acomptes-content").length &&
      $("#partial-collab_acomptes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_collab_acomptes(), 300);
    }

    if (
      $("#partial-entretiens_rhs-content").length &&
      $("#partial-entretiens_rhs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_entretiens_rhs(), 300);
    }

    if (
      $("#partial-arrets_maladies-content").length &&
      $("#partial-arrets_maladies-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_arrets_maladies(), 300);
    }

    if (
      $("#partial-visites_medicales-content").length &&
      $("#partial-visites_medicales-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_visites_medicales(), 300);
    }

    if (
      $("#partial-justificatifs-content").length &&
      $("#partial-justificatifs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_justificatifs(), 300);
    }

    if (
      $("#partial-st_commandes-content").length &&
      $("#partial-st_commandes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_st_commandes(), 300);
    }

    if (
      $("#partial-diplomes-content").length &&
      $("#partial-diplomes-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_diplomes(), 300);
    }

    if (
      $("#partial-formations-content").length &&
      $("#partial-formations-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_formations(), 300);
    }

    if (
      $("#partial-certifications-content").length &&
      $("#partial-certifications-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_certifications(), 300);
    }

    if (
      $("#partial-declarations_competences-content").length &&
      $("#partial-declarations_competences-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_declarations_competences(), 300);
    }

    if (
      $("#partial-materiels-content").length &&
      $("#partial-materiels-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_materiels(), 300);
    }

    if (
      $("#partial-documents-content").length &&
      $("#partial-documents-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_documents(), 300);
    }

    if (
      $("#partial-entretiens_candidats-content").length &&
      $("#partial-entretiens_candidats-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_entretiens_candidats(), 300);
    }

    if (
      $("#partial-collab_cv-content").length &&
      $("#partial-collab_cv-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_collab_cv(), 300);
    }

    if (
      $("#partial-references-content").length &&
      $("#partial-references-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_references(), 300);
    }

    if (
      $("#partial-historique_employe-content").length &&
      $("#partial-historique_employe-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_historique_employe(), 300);
    }

    if (
      $("#partial-propositions-content").length &&
      $("#partial-propositions-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_propositions(), 300);
    }

    if (
      $("#partial-interlocuteurs-content").length &&
      $("#partial-interlocuteurs-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_interlocuteurs(), 300);
    }

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
        $("#target_entreprise_raison_sociale").val(
          $("#filterrific_with_entreprise_raison_sociale").val()
        );
      });
      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        console.log(
          "From contacts_employe_controller.js =======> ",
          element.scrollTop
        );
        document.getElementById("scrollevel").value = element.scrollTop;
      });
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const bonsDeCommandeParam = url.searchParams.get("previous_record");

      if (bonsDeCommandeParam != null) {
        var trElement = $("#contacts_employe_" + bonsDeCommandeParam);
        $("#contacts_employe_" + bonsDeCommandeParam + " td").addClass(
          "highlighted-td"
        );
        $("#contacts_employe_" + bonsDeCommandeParam)
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  contacts_employe_missions() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_missions?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-missions-content").html("");
          $("#partial-missions-content").html(text);
          $("#partial-missions-badge").html(
            "(" +
              $(".show_ajax_for_hm_missions >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_historique_employe(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value;
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort;
      }
    }

    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_historique_employe?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";

      if (order) {
        url += "&" + this.filtertype + "=" + encodeURIComponent(order);
      }

      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-historique_employe-content").html("");
          $("#partial-historique_employe-content").html(text);
          $("#partial-historique_employe-badge").html(
            "(" +
              $(".show_ajax_for_hm_employes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_propositions() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_propositions?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-propositions-content").html("");
          $("#partial-propositions-content").html(text);
          $("#partial-propositions-badge").html(
            "(" +
              $(".show_ajax_for_hm_propositions >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_interlocuteurs() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_contact_interlocuteurs?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-interlocuteurs-content").html("");
          $("#partial-interlocuteurs-content").html(text);
          $("#partial-interlocuteurs-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_contact_interlocuteurs >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_paies_pagination(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort;
      }
    }
    console.log("Tri sélectionné :", order);
    console.log("Tri sélectionné :", event);

    console.log("current_app:", this.current_app);
    console.log("recordid:", this.recordid);
    console.log("filter type est ", this.filtertype);

    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_paies?contacts_employe_id=" +
        this.recordid;

      if (order) {
        url += "&order=" + encodeURIComponent(order);
      }

      url += "&vr2=1";

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          $("#partial-paies-content").html(text);
          $("#partial-paies-badge").html(
            "(" +
              $(".show_ajax_for_hm_paies >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
        .catch((error) =>
          console.error("Erreur lors du chargement des paies :", error)
        );
    } else {
      console.error("Erreur : current_app ou recordid est manquant !");
    }
  }

  contacts_employe_paies() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_paies?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-paies-content").html("");
          $("#partial-paies-content").html(text);
          $("#partial-paies-badge").html(
            "(" +
              $(".show_ajax_for_hm_paies >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_campagne_destinataires() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_campagne_destinataires?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-campagne_destinataires-content").html("");
          $("#partial-campagne_destinataires-content").html(text);
          $("#partial-campagne_destinataires-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_campagne_destinataires >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_employe_materiels() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_employe_materiels?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-employe_materiels-content").html("");
          $("#partial-employe_materiels-content").html(text);
          $("#partial-employe_materiels-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_materiels >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_participations_interventions() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_participations_interventions?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-participations_interventions-content").html("");
          $("#partial-participations_interventions-content").html(text);
          $("#partial-participations_interventions-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_participations_interventions >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_primes() {
    console.log("contacts_employe_primes");
    console.log(this.current_app);
    console.log(this.recordid);
    console.log(this.url_solution);

    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_primes?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-primes-content").html("");
          $("#partial-primes-content").html(text);
          $("#partial-primes-badge").html(
            "(" +
              $(".show_ajax_for_hm_primes >tbody >tr:not(.no_record)").length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_collab_acomptes() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_collab_acomptes?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-collab_acomptes-content").html("");
          $("#partial-collab_acomptes-content").html(text);
          $("#partial-collab_acomptes-badge").html(
            "(" +
              $(".show_ajax_for_hm_collab_acomptes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_entretiens_rhs() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_entretiens_rhs?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-entretiens_rhs-content").html("");
          $("#partial-entretiens_rhs-content").html(text);
          $("#partial-entretiens_rhs-badge").html(
            "(" +
              $(".show_ajax_for_hm_entretiens_rhs >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_arrets_maladies() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_arrets_maladies?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-arrets_maladies-content").html("");
          $("#partial-arrets_maladies-content").html(text);
          $("#partial-arrets_maladies-badge").html(
            "(" +
              $(".show_ajax_for_hm_arrets_maladies >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_visites_medicales() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_visites_medicales?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-visites_medicales-content").html("");
          $("#partial-visites_medicales-content").html(text);
          $("#partial-visites_medicales-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_visites_medicales >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_justificatifs() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_justificatifs?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-justificatifs-content").html("");
          $("#partial-justificatifs-content").html(text);
          $("#partial-justificatifs-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_transport_justificatifs >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_st_commandes() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_st_commandes?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-st_commandes-content").html("");
          $("#partial-st_commandes-content").html(text);
          $("#partial-st_commandes-badge").html(
            "(" +
              $(".show_ajax_for_hm_commandes_st >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_diplomes() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_diplomes?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-diplomes-content").html("");
          $("#partial-diplomes-content").html(text);
          $("#partial-diplomes-badge").html(
            "(" +
              $(".show_ajax_for_hm_diplomes >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_formations() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_formations?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-formations-content").html("");
          $("#partial-formations-content").html(text);
          $("#partial-formations-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_formations_formations >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_certifications() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_certifications?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-certifications-content").html("");
          $("#partial-certifications-content").html(text);
          $("#partial-certifications-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_formations_certifications >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_declarations_competences() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_declarations_competences?contacts_employe_id=" +
        this.recordid +
        "&vr2=1&actif=2";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-declarations_competences-content").html("");
          $("#partial-declarations_competences-content").html(text);
          $("#partial-declarations_competences-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_evaluations_competences >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_materiels() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_employe_materiels?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-materiels-content").html("");
          $("#partial-materiels-content").html(text);
          $("#partial-materiels-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_employe_materiels >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }
  contacts_employe_documents_reset_filter_hm(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    //trouver le form
    let form = event?.currentTarget?.closest("form");
    if (!form) {
      form =
        this.element.closest("form") ||
        document.querySelector(".show_ajax_for_hm_documents")?.closest("form");
    }

    // vider le formulaire (sans déclencher d’events, ni soumettre)
    Array.from(form.elements).forEach((el) => {
      if (el.disabled) return;
      if (el.type === "hidden") return;
      if (el.tagName === "SELECT") el.selectedIndex = -1;
      else if (el.type === "checkbox" || el.type === "radio")
        el.checked = false;
      else if (el.type === "file") el.value = null;
      else el.value = "";
    });

    //mettre toutes les valeurs with_* à "" dans le hidden base
    const baseInput = form?.querySelector(
      "#contacts-employe-hm-documents-base"
    );

    if (baseInput) {
      const qs = new URLSearchParams(baseInput.value || "");
      const normalize = (name) => {
        const i = name.indexOf("with_");
        return i >= 0 ? name.slice(i) : name;
      };

      // blanker toutes les clés with_* déjà présentes dans la base
      for (const k of Array.from(qs.keys())) {
        if (k.includes("with_")) qs.set(k, "");
      }
      //s’assurer que toutes les clés with_* du form existent et sont blankées
      form
        ?.querySelectorAll(
          'input[name*="with_"], select[name*="with_"], textarea[name*="with_"]'
        )
        .forEach((el) => {
          const k = normalize(el.name);
          qs.set(k, "");
        });

      baseInput.value = qs.toString();
    }

    //relancer le chargement AJAX
    this.contacts_employe_documents();
  }

  contacts_employe_documents(event = null) {
    const currentApp = this.current_app;
    const recordId = this.recordid;
    if (!currentApp || !recordId) return;

    // trouver le form
    let form = null;
    if (event?.target && typeof event.target.closest === "function") {
      form = event.target.closest("form");
    }
    if (!form) {
      form = document
        .querySelector(".show_ajax_for_hm_documents")
        ?.closest("form");
    }
    // base cumulée depuis le hidden
    const baseInput =
      form?.querySelector("#contacts-employe-hm-documents-base") ||
      document.querySelector("#contacts-employe-hm-documents-base");
    const baseParams = new URLSearchParams(baseInput?.value || "");

    // valeurs actuelles du form
    const currentParams = form
      ? new URLSearchParams(new FormData(form))
      : new URLSearchParams();

    console.log("currentParams", currentParams);

    console.log("baseParams", baseParams);

    //merge : pour chaque clé with_*
    currentParams.forEach((val, key) => {
      console.log("val,key =======>>>>>>");
      console.log("val ,key=======>>>>>>");
      console.log(val, key);

      console.log("val,key =======>>>>>>");
      console.log("val,key =======>>>>>>");

      if (!key.startsWith("with_")) return;
      if (val !== null && String(val).trim() !== "") {
        baseParams.set(key, val);
      } else {
        // clé présente mais vide -> forcer blank au rendu
        baseParams.set(key, "");
      }
    });

    // mettre le vr2 + id
    baseParams.set("vr2", "1");
    baseParams.set("contacts_employe_id", recordId);

    // tri (si select/clic de th t’envoie une valeur)
    if (event) {
      let order = null;
      if (event.type === "change") order = event.target?.value ?? null;
      else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget?.dataset?.contactsEmployeSort ?? null;
      }
      if (order) baseParams.set(this.filtertype || "order", order);
    }

    const url = `${
      window.location.origin
    }/${currentApp}/contacts_employes/show_ajax_for_hm_documents?${baseParams.toString()}`;

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then((r) => r.text())
      .then((html) => {
        $("#partial-documents-content").html(html);
        $("#partial-documents-badge").text(
          "(" +
            $(".show_ajax_for_hm_documents >tbody >tr:not(.no_record)").length +
            ")"
        );
      })
      .catch(console.error);
  }

  contacts_employe_documents_old(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort; // Pour le clic sur un TH
      }
    }

    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_documents?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";

      if (order) {
        url += "&" + this.filtertype + "=" + encodeURIComponent(order); // Ajouter le tri seulement s'il est défini
      }
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-documents-content").html("");
          $("#partial-documents-content").html(text);
          $("#partial-documents-badge").html(
            "(" +
              $(".show_ajax_for_hm_documents >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_entretiens_candidats() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_entretiens_candidats?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-entretiens_candidats-content").html("");
          $("#partial-entretiens_candidats-content").html(text);
          $("#partial-entretiens_candidats-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_entretiens_candidats >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_collab_cv() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_collab_cv?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-collab_cv-content").html("");
          $("#partial-collab_cv-content").html(text);
          $("#partial-collab_cv-badge").html(
            "(" +
              $(".show_ajax_for_hm_contact_cvs >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

  contacts_employe_references() {
    if (this.current_app && this.recordid) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/contacts_employes/show_ajax_for_hm_references?contacts_employe_id=" +
        this.recordid +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-references-content").html("");
          $("#partial-references-content").html(text);
          $("#partial-references-badge").html(
            "(" +
              $(".show_ajax_for_hm_references >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }
  showLoader() {
    requestAnimationFrame(function () {
      console.log("LOg requestAnimationFrame");
      $(".child-loader").show();
      document.getElementById("child-loader").style.display = "block";
    });
  }

  hideLoader() {
    setTimeout(function () {
      $(".child-loader").hide();
    }, 50);
  }

  async submit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.showLoader();
    this.buttonTextTarget.style.display = "none";
    this.loadingIconTarget.style.display = "inline-block";

    const form = event.target;
    const formData = new FormData(form);
    const queryString = new URLSearchParams(formData).toString();

    try {
      const response = await fetch(`${form.action}?${queryString}`, {
        method: form.method,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (response.ok) {
        const html = await response.text();
        this.resultTarget.innerHTML = html;
      } else {
        console.error("Erreur lors de la requête AJAX !");
      }
    } catch (error) {
      console.error("Erreur de connexion :", error);
    }

    this.buttonTextTarget.style.display = "inline";
    this.loadingIconTarget.style.display = "none";
    this.hideLoader();
  }

  replaceWithInitials(event) {
    const img = event.target;

    // Vérifier si l'élément est bien une image
    if (!(img instanceof HTMLImageElement)) {
      console.error("L'élément cible n'est pas une image", img);
      return;
    }

    // Récupérer les initiales depuis l'attribut data
    const initials = img.dataset.initials || "?";

    // Créer une div pour afficher les initiales
    const div = document.createElement("div");
    div.className = "avatar-initials";
    div.textContent = initials;
    div.title = img.alt; // Ajoute un tooltip

    // Remplacer l'image par la div
    img.replaceWith(div);
  }

  get current_app() {
    return this.data.get("app");
  }

  get params() {
    return this.data.get("params");
  }

  get recordid() {
    return this.data.get("recordid");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }

  get filtertype() {
    return this.data.get("filtertype");
  }
}
